import { Component, HostBinding, OnInit } from '@angular/core';
import {
  ActivationEnd,
  ActivationStart,
  NavigationEnd,
  Router,
  RouterOutlet
} from '@angular/router';
import {
  slideInAnimation,
  sidebarPageContentAnimation,
  sidebarAnimation
} from './animations';
import { EventService } from '@app/event/event.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    slideInAnimation,
    sidebarPageContentAnimation,
    sidebarAnimation
    // animation triggers go here
  ]
})
export class AppComponent implements OnInit {
  title = 'VZP Reach';
  sidebarOpen = true;
  @HostBinding('class.login-page-active') loginPageActive = false;

  constructor(
    private router: Router,
    public eventService: EventService
  ) {}

  prepareRoute(outlet: RouterOutlet) {
    return (
      outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation
    );
  }

  ngOnInit(): void {
    this.router.events.subscribe(e => {
      if (e instanceof ActivationEnd) {
        this.loginPageActive = e.snapshot.routeConfig.path === 'auth';
      }
      if (e instanceof NavigationEnd) {
        const eventsRegex = /\/events.*/;
        const homePage = /\//;
        const whiteListedRoutes = [eventsRegex, homePage];

        const hasAuth = localStorage.getItem('access_token');
        const canView = whiteListedRoutes.some(route =>
          route.test(e.urlAfterRedirects)
        );

        if (!hasAuth && !this.loginPageActive) {
          if (!canView) {
            this.router.navigateByUrl('/auth/login');
          }

        }
      }
    });
  }
}
